package br.com.texeratx.boardgametimeapp.ui.screens.matches.edit

import br.com.texeratx.boardgametimeapp.ui.screens.expansions.model.ExpansionUI
import br.com.texeratx.boardgametimeapp.ui.screens.players.model.PlayerUI

data class MatchEditUiState(
    val date: String,
    val time: String = "19:30",
    val duration: String,
    val observation: String?,

    val players: List<EditablePlayerScoreUI>,

    // 👥 ADD PLAYER
    val isAddPlayerDialogOpen: Boolean = false,
    val isLoadingPlayers: Boolean = false,
    val availablePlayers: List<PlayerUI> = emptyList(),

    // 🧩 EXPANSÕES
    val availableExpansions: List<ExpansionUI> = emptyList(),
    val selectedExpansionIds: List<Long>,
    val isLoadingExpansions: Boolean = false,

    // UI
    val isSaving: Boolean = false,
    val error: String? = null
) {
    val hasValidPlayers =
        players.isNotEmpty() &&
                players.all { it.points.toDoubleOrNull() != null }

    val canSave = hasValidPlayers && !isSaving
}

